import { PhoneIssue } from './phone-issue';

export class Estimate {

  constructor(
    private _key: string,
    private _brand: string = null,
    private _model: string = null,
    private _issues: PhoneIssue[] = [],
    private _shipToCustomer: boolean = false,
    private _state: string = null,
    private _color: string = null,
    private _creationDate: Date = null,
    private _totalAmount: number = null,
    private _totalAmountVat: number = null,
    private _shopId: string = null,
    private _userId: string = null,
    private _imei: string = null,
    private _unrecoveredImei: boolean = true,
    private _password: string = null,
    private _unrecoveredPassword: boolean = true,
    private _note: string = null,
    private _purchaseDate: Date = null,
    private _imgUrls: any[] = [],
    private _deliveryTimes: number = 10,
    private _kaskoPriceVat: number = 0,
    private _isOnlineEstimate: boolean = false,
    private _agentId: string = null,
    private _mshpId: string = null,
  ) { }

  get imgUrls(): any[] {
    return this._imgUrls;
  }
  get purchaseDate(): Date {
    return this._purchaseDate;
  }
  get note(): string {
    return this._note;
  }
  get unrecoveredPassword(): boolean {
    return this._unrecoveredPassword;
  }
  get password(): string {
    return this._password;
  }
  get unrecoveredImei(): boolean {
    return this._unrecoveredImei;
  }
  get imei(): string {
    return this._imei;
  }
  get userId(): string {
    return this._userId;
  }
  public get shopId(): string {
    return this._shopId;
  }
  public get agentId(): string {
    return this._agentId;
  }
  public get mshpId(): string {
    return this._mshpId;
  }
  public get totalAmountVat(): number {
    return this._totalAmountVat;
  }
  public get totalAmount(): number {
    return this._totalAmount;
  }
  public get creationDate(): Date {
    return this._creationDate;
  }
  public get color(): string {
    return this._color;
  }
  public get state(): string {
    return this._state;
  }
  public get shipToCustomer(): boolean {
    return this._shipToCustomer;
  }
  public get issues(): PhoneIssue[] {
    return this._issues;
  }
  public get model(): string {
    return this._model;
  }
  public get brand(): string {
    return this._brand;
  }
  public get key(): string {
    return this._key;
  }
  public get deliveryTimes(): number {
    return this._deliveryTimes;
  }

  public get kaskoPriceVat(): number {
    return this._kaskoPriceVat;
  }

  public get isOnlineEstimate(): boolean {
    return this._isOnlineEstimate;
  }

  issuesToRaw(): any {
    const issues_raw = [];
    for (const issue of this.issues) {
      const issue_raw = {
        name: issue.name,
        code: issue.code,
        brand: issue.brand,
        model: issue.model,
        priority: issue.priority,
        final_customer_price: issue.finalCustomerPrice,
        final_customer_price_vat: issue.finalCustomerPriceVat,
        proceeds: {
          lab_proceed: issue.proceeds.labProceed,
          genius_proceed: issue.proceeds.geniusProceed,
          agent_proceed: issue.proceeds.agentProceed,
          dealer_proceed: issue.proceeds.dealerProceed,
          mshp_proceed: issue.proceeds.mshpProceed
        },
        //kasko_price_vat: issue.kaskoPriceVat,
      };
      issues_raw.push(issue_raw);
    }
    return issues_raw;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/estimate.ts